<script setup lang="ts">
	//import IconNineDots from '@/components/icons/IconNineDots.vue'
	//import MenuNineDots from '@/components/navbars/MenuNineDots.vue'
	import NavbarIconsNotifications from './NavbarIconsNotifications.vue'
	import NavbarIconsTheme from './NavbarIconsTheme.vue'
	import NavbarIconsUser from './NavbarIconsUser.vue'
</script>
<template>
	<ul class="navbar-nav navbar-nav-icons ms-auto flex-row align-items-center">
		<li class="nav-item ps-2 pe-0">
			<NavbarIconsTheme />
		</li>
		<li class="nav-item dropdown">
			<NavbarIconsNotifications />
		</li>
		<li class="nav-item dropdown">
			<NavbarIconsUser />
		</li>
	</ul>
</template>
